/**
 * Angular core components declaration
 **/
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';

/**
 * Admin Modules declaration
 **/
import { LanguageModule } from '../common/services/languages/language.module';


import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';

/**
 * Admin Services declaration
 **/
import { TranslationService } from '../common/services/languages/translation.service';
import { ACMHeaderInterceptorService } from './services/header-interceptor/acm-header-interceptor.service';
import { SubscriptionHeaderInterceptorService } from './services/header-interceptor/subscription-header-interceptor.service';
import { NaviHeaderInterceptorService } from './services/header-interceptor/navi-header-interceptor.service';
import { OrchestrationService } from './services/orchestration-service/orchestration.service';

/**
 Admin Components declaration
 **/
import { SearchBarComponent } from './search-bar/search-bar.component';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { ResultCustomerComponent } from './acm/result-customer/result-customer.component';
import { SideNavComponent } from './acm/side-nav/side-nav.component';
import { UpdateAccountComponent } from './acm/update-account/update-account.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { DataConsentComponent } from './subscription/data-consent/data-consent.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { VehiclesListComponent } from './subscription/vehicles-list/vehicles-list.component';
import { RemoteStatusComponent } from './subscription/remote-status/remote-status.component';
import { VehicleSummaryComponent } from './subscription/vehicle-summary/vehicle-summary.component';
import { VehiclePackageComponent } from './subscription/vehicle-package/vehicle-package.component';
import { SubscriptionDetailsComponent } from './subscription/subscription-details/subscription-details.component';
import { EmergencyContactComponent } from './subscription/emergency-contact/emergency-contact.component';
import { UpdateRemoteUserComponent } from './subscription/update-remote-user/update-remote-user.component';

/**
 * Admin Modules declaration
 **/
import { PhonePipe } from '../common/pipes/phone.pipe';
import { PostalCodeDirective } from '../common/pipes/directives/postal-code.directive';
import { CustomerComponent } from './customer/customer.component';
import { RemoteCommandComponent } from './subscription/remote-command/remote-command.component';
import { SubscriptionHistoryComponent } from './subscription/subscription-history/subscription-history.component';
import { AdvancedFeaturesComponent } from './customer/advanced-features/advanced-features.component';
import { AdvancedSubscriptionFeaturesComponent } from './subscription/subscription-details/advanced-subscription-features/advanced-subscription-features.component';
import { VerifyAddressComponent } from './customer/verify-address/verify-address.component';
import { ProvisioningComponent } from './provisioning/provisioning.component';
import { CmsTicketComponent } from './cms-ticket/cms-ticket.component';
import { CmsHeaderInterceptorService } from './services/header-interceptor/cms-header-interceptor.service';
import { TssComponent } from './tss/tss.component';
import { GuidAlignmentComponent } from './customer/guid-alignment/guid-alignment.component';
import { CustomerHistoryComponent } from './acm/customer-history/customer-history.component';
import { PhoneCapabilityComponent } from './subscription/phone-capability/phone-capability.component';
import { VehicleHistoryComponent } from './subscription/vehicle-history/vehicle-history.component';
import { AppFeaturesComponent } from './customer/app-features/app-features.component';
import { ProvisioningHistoryComponent } from './provisioning/provisioning-history/provisioning-history.component';
import { LinkedAccountsComponent } from './subscription/linked-accounts/linked-accounts.component';
import { UserProfileComponent } from './customer/user-profile/user-profile.component';
import { DigitalKeyComponent } from './subscription/digital-key/digital-key.component';
import { GiveGoodwillComponent } from './subscription/give-goodwill/give-goodwill.component';
import { CustomerDetailsComponent } from './customer/customer-details/customer-details.component';
import { RemoteConfirmationComponent } from './subscription/remote-confirmation/remote-confirmation.component';
import { AuthorizeRemoteComponent } from './subscription/authorize-remote/authorize-remote.component';
import { RemotelistSidemenuComponent } from './customer/remotelist-sidemenu/remotelist-sidemenu.component';
import { ShowAddTrialServicesModalComponent } from './subscription/show-add-trial-services-modal/show-add-trial-services-modal.component';
import { ShowFlagsComponent } from './provisioning/show-flags/show-flags.component';
import { AdminRoutingModule } from './admin-routing.module';
import { RentalEvComponent } from './rental-ev/rental-ev.component';
import { RentalEvCreditsPopupComponent } from './dailag_components/rental-ev-credits-popup/rental-ev-credits-popup.component';
import { SurvivorAccountComponent } from './acm/survivor-account/survivor-account.component';
@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [FormsModule,
    ReactiveFormsModule,
    LanguageModule,
    RouterModule,
    FileUploadModule,
    AdminRoutingModule,
    CommonModule, SearchBarComponent,
    AdminMainComponent,
    ResultCustomerComponent,
    SideNavComponent,
    PhonePipe,
    UpdateAccountComponent,
    SurvivorAccountComponent,
    ConfirmationComponent,
    PostalCodeDirective,
    SearchResultsComponent,
    VehiclesListComponent,
    DataConsentComponent,
    RemoteStatusComponent,
    DigitalKeyComponent,
    SearchResultsComponent,
    VehicleSummaryComponent,
    VehiclePackageComponent,
    SearchResultsComponent,
    SubscriptionDetailsComponent,
    EmergencyContactComponent,
    CustomerComponent,
    RemoteCommandComponent,
    SubscriptionHistoryComponent,
    AdvancedFeaturesComponent,
    AdvancedSubscriptionFeaturesComponent,
    VerifyAddressComponent,
    ProvisioningComponent,
    ProvisioningHistoryComponent,
    CmsTicketComponent,
    TssComponent,
    PhoneCapabilityComponent,
    GuidAlignmentComponent,
    CustomerHistoryComponent,
    VehicleHistoryComponent,
    AppFeaturesComponent,
    LinkedAccountsComponent,
    UserProfileComponent,
    GiveGoodwillComponent,
    CustomerDetailsComponent,
    RemoteConfirmationComponent,
    AuthorizeRemoteComponent,
    RemotelistSidemenuComponent,
    ShowAddTrialServicesModalComponent,
    UpdateRemoteUserComponent,
    ShowFlagsComponent,
    RentalEvComponent,
    RentalEvCreditsPopupComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ACMHeaderInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: NaviHeaderInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SubscriptionHeaderInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CmsHeaderInterceptorService, multi: true },
        TranslationService,
        PhonePipe,
        DatePipe,
        OrchestrationService,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AdminModule {
  constructor() {
  }
}
